import type { ReactNode } from 'react';
import { Box, Flex } from '@radix-ui/themes';
import { Badge } from './Badge';
import { Card } from './Card';
import { Text } from './Text';

export type IntentionsSpotsSection = {
  title: string;
  labels: string[];
  emptyText?: string;
  badgeVariant?: 'solid' | 'outline';
};

type IntentionsSpotsCardProps = {
  sections: IntentionsSpotsSection[];
  action?: ReactNode;
  className?: string;
};

export function IntentionsSpotsCard({ sections, action, className }: IntentionsSpotsCardProps) {
  const visible = sections.filter(section => section.labels.length > 0 || section.emptyText);
  if (visible.length === 0) return null;

  return (
    <Box mb="2" py="2" width="100%">
      <Card className={className}>
        <Flex direction="column" gap="5">
          {visible.map((section, index) => (
            <Flex key={section.title} direction="column" gap="3">
              <Flex align="center" justify="between" gap="2">
                <Text
                  size="1"
                  color="gray"
                  style={{ letterSpacing: '0.08em', textTransform: 'uppercase' }}
                >
                  {section.title}
                </Text>
                {index === 0 && action ? action : null}
              </Flex>

              <Flex align="center" gap="2" wrap="wrap">
                {section.labels.length > 0 ? (
                  section.labels.map(label => (
                    <Badge
                      key={label}
                      color="gray"
                      highContrast={section.badgeVariant !== 'outline'}
                      variant={section.badgeVariant === 'outline' ? 'outline' : undefined}
                    >
                      {label}
                    </Badge>
                  ))
                ) : (
                  <Text size="1" color="gray">
                    {section.emptyText}
                  </Text>
                )}
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Card>
    </Box>
  );
}
